import { render } from "./WorkloadApproval.vue?vue&type=template&id=4924f20c"
import script from "./WorkloadApproval.vue?vue&type=script&lang=js"
export * from "./WorkloadApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__